class AccountSettings.InstagramHashtagListeningActionsView extends Backbone.View
  template: JST['backbone/templates/account_settings/topics/instagram_listening_hashtag_actions']
  tagName: 'div'
  className: 'hashtag-actions-div'
  running: 'Running'
  new: 'New'
  expired: 'Expired'
  inactive: 'Inactive'

  initialize: (hashtag_status) ->
    @buttonText = ''
    @status = hashtag_status

  render: () ->
    @_setActionContainerText(@status)
    @$el.html(@template({buttonText : @buttonText}))
    @

  _setActionContainerText: (status) ->
    if(status == @running)
      @buttonText = 'Disable'
    else
      if(status == @inactive)
        @buttonText = 'Enable'
      else
        @buttonText = ''
